var exports = {
  "XG": "UnreadChannelsContent.module__scroller___UkpfXz",
  "IX": "UnreadChannelsContent.module__stickyChannelHeader___UkpfXz",
  "bm": "UnreadChannelsContent.module__guildGroup___UkpfXz",
  "p_": "UnreadChannelsContent.module__list___UkpfXz",
  "nM": "UnreadChannelsContent.module__row___UkpfXz",
  "fe": "UnreadChannelsContent.module__rowGroupEnd___UkpfXz",
  "S7": "UnreadChannelsContent.module__channelCard___UkpfXz",
  "sM": "UnreadChannelsContent.module__srOnly___UkpfXz",
  "m$": "UnreadChannelsContent.module__channelHeadingButton___UkpfXz",
  "l6": "UnreadChannelsContent.module__collapseContainer___UkpfXz",
  "WE": "UnreadChannelsContent.module__messageStream___UkpfXz",
  "q6": "UnreadChannelsContent.module__previewFooter___UkpfXz",
  "DI": "UnreadChannelsContent.module__viewAllButton___UkpfXz",
  "mw": "UnreadChannelsContent.module__messageRow___UkpfXz",
  "n": "UnreadChannelsContent.module__messageActions___UkpfXz",
  "nn": "UnreadChannelsContent.module__jumpButton___UkpfXz",
  "cS": "UnreadChannelsContent.module__collapseButton___UkpfXz",
  "$u": "UnreadChannelsContent.module__collapseButtonCollapsed___UkpfXz",
  "DE": "UnreadChannelsContent.module__collapseIcon___UkpfXz",
  "FW": "UnreadChannelsContent.module__headerIconButton___UkpfXz",
  "nr": "UnreadChannelsContent.module__headerIcon___UkpfXz",
  "mc": "UnreadChannelsContent.module__previewDateDivider___UkpfXz",
  "En": "UnreadChannelsContent.module__cardPlaceholder___UkpfXz",
};

module.exports = exports;
